import { DownloadCta } from '../components/DownloadCta';
import { StoreBadges } from '../components/StoreBadges';
import { useI18n } from '../i18n/useI18n';
import { useSeo } from './useSeo';

export function DownloadPage() {
  const { t } = useI18n();
  useSeo('seo.download.title', 'seo.download.description');

  return (
    <main>
      <section className="page-hero">
        <p className="eyebrow">{t('download.eyebrow')}</p>
        <h1>{t('download.pageTitle')}</h1>
        <p>{t('download.pageText')}</p>
      </section>
      <section className="section download-grid">
        <article className="store-card store-card-featured">
          <span>{t('download.storeLinks')}</span>
          <StoreBadges />
        </article>
        <article className="store-card muted">
          <span>{t('download.testing')}</span>
          <strong>{t('download.testingText')}</strong>
        </article>
      </section>
      <DownloadCta />
    </main>
  );
}
